var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.showCreateProjectForm)?_c('project-creation-form',{on:{"save":_vm.save}}):_c('vs-button',{attrs:{"label":"New project","full-width":""},on:{"click":function($event){return _vm.toggleCreateProjectForm(false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }